// Copyright (c) StrangeBee 2024

import { Dropdown, Menu } from 'antd';
import React, { ReactElement, ReactNode, useState } from 'react';
import { useLocalMessage } from '@Helpers/';
import { ICONS } from '@Constants/iconsApp';
import { THButton } from '@Molecules/Inputs/THButton/THButton';

import './QuickFilterList.scss';

export interface QuickFilterInterface {
    label?: ReactNode;
    callback?: () => void;
    divider?: boolean;
    title?: boolean;
}

interface QuickFilterListProps {
    quickFilterList: QuickFilterInterface[];
    label?: string;
    icon?: ReactElement;
}

const QuickFilterList = ({ quickFilterList, label, icon }: QuickFilterListProps): ReactElement => {
    const i = useLocalMessage();
    const [showMenu, setShowMenu] = useState<boolean>(false);

    const menu = (
        <Menu className="quick-filter-list">
            {quickFilterList.map(({ label = '', callback, divider, title }, index) => {
                if (divider) {
                    return <Menu.Divider key={index} />;
                }

                if (title) {
                    return (
                        <div className="quick-filter-list__title" key={index}>
                            {label}
                        </div>
                    );
                }

                return (
                    <Menu.Item
                        className="quick-filter-list__label"
                        key={index}
                        onClick={(): void => {
                            setShowMenu(false);
                            callback?.();
                        }}
                    >
                        {label}
                    </Menu.Item>
                );
            })}
        </Menu>
    );

    return (
        <div className="quick-filter-list">
            <Dropdown
                overlay={menu}
                visible={showMenu}
                onVisibleChange={(isVisible): void => setShowMenu(isVisible)}
                trigger={['click']}
            >
                <THButton type="default">
                    {icon || <ICONS.FilterOutlined className="hide-on-visible" />}
                    <span className="button-text">{label || i('filter.quick.title')}</span>
                    {showMenu ? (
                        <ICONS.UpCircleOutlined className="color-primary" />
                    ) : (
                        <ICONS.DownCircleOutlined className="color-primary" />
                    )}
                </THButton>
            </Dropdown>
        </div>
    );
};

export default QuickFilterList;
